import * as yup from 'yup';

const validationSchema = yup.object().shape({
  family: yup.array().of(
    yup.object().shape({
      firstName: yup
        .string()
        .required('First name is required')
        .matches(/^[A-Za-z\s]+$/, 'First name must contain only letters')
        .min(2, 'First name must be at least 2 characters')
        .max(50, 'First name must not exceed 50 characters'),
      middleName: yup
        .string()
        .nullable()
        .matches(/^[A-Za-z\s]*$/, 'Middle name must contain only letters')
        .max(50, 'Middle name must not exceed 50 characters'),
      lastName: yup
        .string()
        .required('Last name is required')
        .matches(/^[A-Za-z\s]+$/, 'Last name must contain only letters')
        .min(2, 'Last name must be at least 2 characters')
        .max(50, 'Last name must not exceed 50 characters'),
      passport: yup
        .string()
        .required('Passport is required')
        .matches(/^[A-Za-z0-9]+$/, 'Passport must be alphanumeric')
        .min(6, 'Passport must be at least 6 characters')
        .max(20, 'Passport must not exceed 20 characters'),
      dob: yup
        .date()
        .nullable()
        .required('Date of birth is required')
        .typeError('Please enter a valid date'),
      relationship: yup
        .string()
        .nullable()
        .max(30, 'Relationship must not exceed 30 characters'),
    }),
  ),
});

export { validationSchema };
